'use client';

import React, { useState } from 'react';
import { placeMapUrl } from '../../lib/placeMap';

/**
 * A listing's image well filled with a map of where it is, with the store's
 * pin at the centre. ca_preview only (callers gate it). Fills its
 * positioned parent. If the picture fails, the warm tile stays, pin and all,
 * so the well is never blank.
 */
export default function PlaceMapTile({
  lat,
  lng,
  width = 480,
  height = 320,
  zoom = 10,
  label,
  className = '',
  eager = false,
}: {
  lat: number;
  lng: number;
  width?: number;
  height?: number;
  zoom?: number;
  /** Small caption in the corner (e.g. "Map · Glenisla, VIC"). */
  label?: string;
  className?: string;
  eager?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  return (
    <div className={`ca-placemap ${className}`} data-testid="place-map-tile">
      {!failed && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={placeMapUrl(lat, lng, width, height, zoom)}
          alt=""
          aria-hidden="true"
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          onError={() => setFailed(true)}
        />
      )}
      <span className="ca-placemap__pin" aria-hidden="true">
        <svg width="26" height="34" viewBox="0 0 26 34"><path d="M13 33s11-11.6 11-20A11 11 0 1 0 2 13c0 8.4 11 20 11 20z" fill="#1c1e20" stroke="#fff" strokeWidth="2" /><circle cx="13" cy="13" r="4.2" fill="#fff" /></svg>
      </span>
      {label && <span className="ca-placemap__label">{label}</span>}
    </div>
  );
}
